import Vue from 'vue';
import simpleDDP from 'simpleddp';
import ws from 'isomorphic-ws';

const options = {
  endpoint: process.env.VUE_APP_SERVER_HOST,
  SocketConstructor: ws,
  reconnectInterval: 5000,
};

Vue.prototype.$ddp = new simpleDDP(options);
